import { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';
import DBHeader from 'src/components/Headers/DialogBoxHeader';
import { CustomDialogProps } from 'src/models/DialogBox.interface';
import Scrollbar from 'src/components/StyledComponents/StyledScrollbar';
import { ContentGrid } from './CustomBox.styles';
import {
  CloseIcon,
  StyledDialog,
} from 'src/components/DialogBox/DialogBox.styles';
import {
  StyledDialogContent,
  SubmitButton,
} from 'src/components/DialogBox/DialogBox.styles';

const SingleColumnDialog: FC<CustomDialogProps> = ({
  height = '820px',
  width = '620px',
  open,
  handleClose,
  title,
  subtitle,
  children,
  onSubmit,
  smScreen,
  buttonLabel = 'Save',
  buttonWidth = '100px',
  formBottomMargin = '0px',
  buttonDisabled,
}) => {
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      width={width}
      height={height}
    >
      <Box sx={{ position: 'relative' }}>
        <DBHeader title={title} subtitle={subtitle} />
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </Box>

      <Scrollbar thumbColor="var(--loader-color)">
        <StyledDialogContent>
          <form style={{ marginBottom: formBottomMargin }} onSubmit={onSubmit}>
            <ContentGrid smScreen={smScreen}>{children}</ContentGrid>
            <SubmitButton
              className="btn-primary"
              type="submit"
              disabled={buttonDisabled}
              buttonWidth={buttonWidth}
              marginleft={'40px'}
            >
              {buttonDisabled ? (
                <CircularProgress
                  size={24}
                  sx={{
                    color: 'var(--bg-color)',
                  }}
                />
              ) : (
                buttonLabel
              )}
            </SubmitButton>
          </form>
        </StyledDialogContent>
      </Scrollbar>
    </StyledDialog>
  );
};

export default SingleColumnDialog;
